import { createSlice } from "@reduxjs/toolkit";
const tierPerformanceSlice = createSlice({
    name: 'tierPerformance',
    initialState: {
        tierPerformance: null
    },
    reducers: {
        setTierPerformance: (state, action) => {
            state.tierPerformance = action.payload.tierPerformance
        }
    }
});
export const addTierPerformance = tierPerformanceSlice.actions.setTierPerformance;
export default tierPerformanceSlice.reducer;
